"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unprotected = void 0;
exports.unprotected = Symbol();
